import ApiClient from './ApiClient'

const API_NAME = 'WeConnect'
const BASE_PATH = 'business'

const client = new ApiClient(API_NAME)

export default {
  getGroup(businessId) {
    return client.get(`/${BASE_PATH}/${businessId}/bridal-item/group`)
  },
  /**
   * コーディネート一覧を取得する
   * @param {number} businessId 案件ID
   * @param {number} bridalItemGroupId 婚礼アイテムグループID
   * @returns {Promise<any>} レスポンス
   *
   */
  getCoordinate(businessId, bridalItemGroupId) {
    return client.get(`/${BASE_PATH}/${businessId}/coordinate`, {bridal_item_group_id: bridalItemGroupId})
  },
  /**
   * コーディネートを対象／対象外にする
   * @param {number} businessId 案件ID
   * @param {object} data コーディネート対象データ
   * @returns {Promise<any>} レスポンス
   *
   */
  updateCoordinate(businessId, data) {
      const url = `/${BASE_PATH}/${businessId}/coordinate`
      return client.put(url, data)
  },
  getSubgroup(businessId, groupId) {
    return client.get(`/${BASE_PATH}/${businessId}/bridal-item/subgroup/${groupId}`)
  },
  getItem(businessId, subgroupId, irregular, coordinateId) {
    return client.get(`/${BASE_PATH}/${businessId}/bridal-item/${subgroupId}?irregular=${irregular}&coordinate_id=${coordinateId}`)
  },
  getFavorite(businessId) {
    return client.get(`/${BASE_PATH}/${businessId}/bridal-item/favorite`)
  },
  updateFavorited(businessId, data) {
    return client.put(`/${BASE_PATH}/${businessId}/bridal-item/favorite`, data)
  },
}